import { render, staticRenderFns } from "./SerialAndModelNumber.vue?vue&type=template&id=5aeae468"
import script from "./SerialAndModelNumber.vue?vue&type=script&lang=js"
export * from "./SerialAndModelNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports